@switch (tag()) {
  @case('div') {
    <div [innerHTML]="formatted()" [class]="innerClass()"></div>
  }
  @case('span') {
    <span [innerHTML]="formatted()" [class]="innerClass()"></span>
  }
  @default {
    <p [innerHTML]="formatted()" [class]="innerClass()"></p>
  }
}
